import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { FormHeader } from 'components/_basic/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';

import { financialPlanOptionsToComponentMap, IFinancialPerformanceValuesType } from './utils/form';
import { FinancialPlanChipSelector } from '../components/FinancialPlanChipSelector';
import { useGetFinancialPerfomanceOptions } from '../hooks/useGetFinancialPerfomanceOptions';
import { ActiveTabContextProvider, useTabChangeContext } from '../hooks/useTabChangeContext';

export const FinancialPerformanceContent: FC = () => {
  const { t } = useTranslation();

  const { activeTab, onTabChange } = useTabChangeContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.FINANCIAL_PLAN,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_FINANCIAL_PLAN.FINANCIAL_PERFORMANCE,
  );

  const Component = financialPlanOptionsToComponentMap[activeTab.value as IFinancialPerformanceValuesType];

  const options = useGetFinancialPerfomanceOptions();

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('financialPlan.title')}
          badgeText={t('financialPlan.financialPerformance.title')}
        />
      </FormSectionCard>

      <FinancialPlanChipSelector options={options} selected={activeTab} onChange={onTabChange} />

      <Component />
    </>
  );
};

export const FinancialPerformance: FC = () => {
  const options = useGetFinancialPerfomanceOptions();
  return (
    <ActiveTabContextProvider initialValue={options[0]}>
      <FinancialPerformanceContent />
    </ActiveTabContextProvider>
  );
};
